import React, { useEffect } from "react";
import service1 from "../../assets/img/service_3.png";
import phone_icon from "../../assets/img/phone.png";
import { ReactTyped } from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../App.css";
import { Link } from "react-router-dom";

const AirbnbCleaning = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="service_detail_page">
      <h2 className="service_detail_title" data-aos="fade-down">
        Airbnb Cleaning
      </h2>

      <img
        src={service1}
        alt="Airbnb Cleaning"
        className="service_detail_image"
        data-aos="zoom-in"
      />

      <p className="service_detail_cta" data-aos="fade-up">
        Turnovers managed properly.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Airbnb cleaning in Auckland structured around booking schedules,
        presentation standards and asset protection. We coordinate turnovers
        with timing discipline, reporting clarity and consistent communication.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Each property runs on a documented process. Scheduled attendance,
        condition checks, linen coordination if required and clear billing
        records. Any concerns are flagged promptly so hosts stay informed.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Eco conscious products are used where appropriate, keeping properties
        fresh without harsh chemical residue.
      </p>

      <h4 className="service_subheading" data-aos="fade-up">
        Who We Support
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Airbnb hosts</li>
        <li>Short stay operators</li>
        <li>Property managers and co hosts</li>
        <li>Multi listing portfolios</li>
      </ul>

      <h4 className="service_subheading" data-aos="fade-up">
        Why Luxe Sparkle
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Turnover scheduling aligned to bookings</li>
        <li>Condition reporting protects your asset</li>
        <li>Linen supply options simplify logistics</li>
        <li>Clear communication with no guesswork</li>
      </ul>

      <p className="service_detail_cta" data-aos="fade-up">
        Presentation stays consistent. Reviews stay protected.
      </p>

      <div className="service_btn_wrapper" data-aos="fade-up">
        <Link to="/booking" className="service_btn">
          Get a Free Quote
        </Link>
      </div>

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AirbnbCleaning;
